import React from "react";

function FAQ() {
  return (
    <div className="hs-accordion-group flex flex-col gap-4">
      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          How er Become Best Among Others?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>

      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          Why Choose Us For Your Product?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>

      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          What We Offer To You?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>

      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          How We Provide Services For You?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>

      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          How We Provide Services For You?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>

      <div className="hs-accordion bg-navySemi shadow-md rounded-xl">
        <button
          className="hs-accordion-toggle group p-4 flex justify-between items-center w-full text-whiteSemi text-sm xl:text-base font-dmSans hs-accordion-active:font-bold transition"
          aria-controls=""
        >
          How We Provide Services For You?
          <span className="material-symbols-outlined hs-accordion-active:rotate-180 duration-300">
            expand_more
          </span>
        </button>
        <div className="hs-accordion-content w-full hidden overflow-hidden transition-[height] duration-300">
          <p className="bg-navyDark p-4 m-4 text-whiteSemi rounded-lg">
            We are committed to sustainability and reducing our environmental
            impact through our products and manufacturing processes. We are
            committed to sustainability and reducing our environmental impact
            through our products and manufacturing processes. We are committed
            to sustainability and reducing our environmental impact through our
            products and manufacturing processes.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
